module.exports = __webpack_public_path__ + "img/champions-poster.866bfafd.png";